import {gql} from '@apollo/client';
import {ReviewTaskFiltersTypeInput, ReviewTaskListItem} from '../types/ReviewTaskType';

export const APPROVE_REVIEW_TASK = gql`
    mutation ApproveReviewTask(
        $reviewTaskId: Long!,
        $commentJson: String
    ) {
        approveReviewTask(
            reviewTaskId: $reviewTaskId,
            commentJson: $commentJson
        ) {
            reviewTaskId
            bizType
            bizId
            status
            reviewerId
            reviewedAt
        }
    }
`;

export const REJECT_REVIEW_TASK = gql`
    mutation RejectReviewTask(
        $reviewTaskId: Long!,
        $commentJson: String
    ) {
        rejectReviewTask(
            reviewTaskId: $reviewTaskId,
            commentJson: $commentJson
        ) {
            reviewTaskId
            bizType
            bizId
            status
            reviewerId
            reviewedAt
        }
    }
`;

export interface ApproveReviewTaskMutationResponse {
    approveReviewTask: ReviewTaskListItem;
}

export interface RejectReviewTaskMutationResponse {
    rejectReviewTask: ReviewTaskListItem;
}

export interface ReviewTaskActionMutationVariables {
    reviewTaskId: number;
    /** 审核评论 JSON 字符串：{schemaVersion:1, lang:"zh|en|es", tagKeys:[], text:""} */
    commentJson?: string | null;
}

/** 导出客诉审核工作台（异步生成，去下载中心领取；导出当前筛选全量） */
export const GENERATE_REVIEW_TASK_DOWNLOAD_REPORT = gql`
    mutation GenerateReviewTaskDownloadReport(
        $filters: ReviewTaskFiltersTypeInput!,
        $language: String,
        $timezone: String
    ) {
        generateReviewTaskDownloadReport(
            filters: $filters,
            language: $language,
            timezone: $timezone
        ) {
            success
            errorCode
            fileName
        }
    }
`;

export interface GenerateReviewTaskDownloadReportResult {
    success: boolean;
    errorCode?: string | null;
    fileName?: string | null;
}

export interface GenerateReviewTaskDownloadReportResponse {
    generateReviewTaskDownloadReport: GenerateReviewTaskDownloadReportResult;
}

export interface GenerateReviewTaskDownloadReportVariables {
    filters: ReviewTaskFiltersTypeInput;
    language?: string | null;
    timezone?: string | null;
}
